import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { NAME_SPACE } from 'i18n';
import { FormPage, useRequestLoading, ButtonSave, ButtonBack } from 'shared';
import { PATH } from 'app.routes.const';
import { FormOperator } from './FormOperator';
import { useOperator } from './useOperator';

export function EditOperator() {
  const { id } = useParams();
  const { operator, createOperator, updateOperator, errorInfo, setErrorInfo } = useOperator(id);
  const { t } = useTranslation(NAME_SPACE.OPERATORS);
  const $formRef = useRef(null);
  const history = useHistory();
  const { requestLoading, callbackRequest } = useRequestLoading();

  async function handleSubmit(operator) {
    await callbackRequest(async () => {
      setErrorInfo({ message: '', detail: '' });
      id ? await updateOperator(operator) : await createOperator(operator);
      history.push(PATH.OPERATORS.LIST);
    });
  }

  function handleSaveClick() {
    $formRef.current.submit();
  }

  function handleGoBack() {
    history.push(PATH.OPERATORS.LIST);
  }

  function composeActionButtons() {
    const actionButtons = [
      { onClick: handleGoBack, component: ButtonBack },
      {
        onClick: handleSaveClick,
        enableOnDirty: true,
        component: ButtonSave
      }
    ];

    return actionButtons;
  }

  return (
    <FormPage
      title={t('singularName')}
      disabled={requestLoading}
      buttons={composeActionButtons()}
      onSubmit={handleSubmit}
    >
      <FormOperator errors={errorInfo} formRef={$formRef} operator={{ ...operator }} />
    </FormPage>
  );
}
